export const isEmail = (str: string): boolean => {
  return /.+@.+\...+/i.test(str)
}
